module.exports = __webpack_public_path__ + "static/media/smile7.eee00c26.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/smileImg/smile7.png
// module id = 80
// module chunks = 0